module.exports = __webpack_public_path__ + "static/mo34-1a326f91296962d0ba1f081222570e40.png";